export const metaExpireDateInSeconds = (metas) => {
  if (!metas.length) return 0;
  return metas[0].broadcastedAt + metas[0].expectedDuration;
};
